export var EHeadingType = /*#__PURE__*/function (EHeadingType) {
  EHeadingType["AdvancedFiltersAuthPermission"] = "advancedFiltersAuthPermission";
  EHeadingType["PhoneAuthPermission"] = "phoneAuthPermission";
  EHeadingType["InformationPermission"] = "informationPermission";
  EHeadingType["BuyCommercialAnalyticsPermission"] = "buyCommercialAnalyticsPermission";
  EHeadingType["ThereIsAnAccount"] = "thereIsAnAccount";
  EHeadingType["NewOfferForm"] = "newOfferForm";
  EHeadingType["SaveSearchPermission"] = "saveSearchPermission";
  EHeadingType["SelectRealtor"] = "selectRealtor";
  return EHeadingType;
}({});